// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"b0665166","noResultsContainer":"184a6e87","productDetailsModalContent":"cbda688d","ProductInfoSwitcher":"56e45b76","AutoSuggest":"37092707"}[chunkId] + ".css";
};